/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { AuthenticationService } from './service/AuthenticationService';
import { NavigationService } from './service/NavigationService';

// Components
import { loginViewComponent } from './component/LoginView';

// Directives
import { PermissionExceptFactory } from './component/PermissionExcept';
import { PermissionOnlyFactory } from './component/PermissionOnly';

angular.module('serfimtic.gmao.security', ['ui.router', 'ngResource'])
.service('authenticationService', AuthenticationService)
.service('navigationService', NavigationService)
.component('loginView', loginViewComponent)
.directive('permissionExcept', PermissionExceptFactory)
.directive('permissionOnly', PermissionOnlyFactory)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.componentState('login', 'loginView', '/login', 'ui.login', {
            target: {
                name: 'gmao.dashboard',
                params: null
            }
        }))
        .state(State.templateState('gmao.forbidden', require('./component/forbidden.html'), '/forbidden',
            'ui.forbidden'));
})
.run(($transitions, authenticationService, navigationService) => {
    /** @ngInject */

    // Handles state permissions, by intercepting transition start events.
    // Due to incompatibilities between UI-router 1.0.0-rc.1 and angular-permission, this later library cannot be used
    // on the project. To anticipate a possible resolution of this incompatibilities, specific directives and validation
    // service were developped in the security module. The configuration of states and directives follows the
    // conventions in the angular-permission library, so as a migration to this library is possible in the future, at
    // low cost.
    $transitions.onStart({}, transition => navigationService.validateTransition(transition));

    // Load the user session, if any.
    authenticationService.loadSession();
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/security/SecurityModule.js